// extracted by mini-css-extract-plugin
export var metric = "MetricCard-module--metric--kqI1m";
export var metricIcon = "MetricCard-module--metricIcon--iswVn";
export var metricLabel = "MetricCard-module--metricLabel--KM4KM";
export var metricNumber = "MetricCard-module--metricNumber--gxMvy";
export var metricTitle = "MetricCard-module--metricTitle--YjYHj";
export var primary = "#06004d";
export var secondary = "#4dafd7";